var _rect, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1ColumnIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 6,
    rx: 2,
    fill: "#00322E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 9,
    width: 24,
    height: 6,
    rx: 2,
    fill: "#00322E"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 18,
    width: 24,
    height: 6,
    rx: 2,
    fill: "#00322E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1ColumnIcon);
export default __webpack_public_path__ + "static/media/1column-icon.984229fc7ba894b65c8abeb3d111ca1b.svg";
export { ForwardRef as ReactComponent };